export const UPDATE_AUTO_RENEW_FLAG_MODAL = 'UPDATE_AUTO_RENEW_FLAG_MODAL';
